import React, { useState } from "react";
import Layout from "../Component/Layout";
import { Nav } from "react-bootstrap";
import { BiSolidPencil, BiTrash } from "react-icons/bi";
import Inputbox from "../Component/Inputbox";
import Button from "../Component/Button";
import REACT_APP_API_URL from "../utils/constant";
import { showToast } from "../helper/Toster";
import { useEffect } from "react";
import Swal from "sweetalert2";
import * as bootstrap from "bootstrap";

const Links = () => {
  const [activeTab, setActiveTab] = useState("accommodation");
  const [editLinkId, setEditLinkId] = useState(null);

  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [type, setType] = useState("");
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({
    title: "",
    link: "",
  });

  const [links, setLinks] = useState([]);
  const [filteredLinks, setFilteredLinks] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLinkAdd, setIsLinkAdd] = useState(false);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setType(tab);
  };

  useEffect(() => {
    handleGetLinks();
  }, [activeTab, currentPage, isLinkAdd]);

  const modalIdMap = {
    accommodation: "addAccommodation",
    travel: "addTravel",
    meal: "addMeal",
    golf: "addGolf",
    entertainment: "addEntertainment",
  };

  const handleCloseForm = () => {
    setErrors({
      title: "",
      link: "",
    });
    setTitle("");
    setLink("");
    setEditLinkId(null);
  };

  const handleAddLink = async () => {
    console.log("working");
    console.log(type);
    console.log(activeTab);

    try {
      let response = await fetch(`${REACT_APP_API_URL}add-link`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        },
        body: JSON.stringify({
          title,
          url: link,
          type,
        }),
      });

      response = await response.json();
      console.log(response);

      if (response.success) {
        showToast("success", "Link created successfully");
        setIsLinkAdd(true);

        const modalId = modalIdMap[activeTab];
        if (modalId) {
          const modalEl = document.getElementById(modalId);
          const modalInstance = bootstrap.Modal.getInstance(modalEl);
          modalInstance?.hide();
        }
        handleCloseForm();
      } else {
        showToast("error", "Link not created");
      }
    } catch (error) {
      console.error(error);
      showToast("error", "Something went wrong");
    } finally {
      setLink("");
      setTitle("");
    }
  };

  const handleAddSubmit = (e) => {
    e.preventDefault();

    console.log("working");

    const newErrors = {
      title: "",
      link: "",
    };

    let hasError = false;

    if (!title) {
      newErrors.title = "Please enter title";
      hasError = true;
    } else if (title.trim() === "") {
      newErrors.title = "Spaces are not allowed.";
      hasError = true;
    }

    const isValidURL = (url) => {
      try {
        new URL(url);
        return true;
      } catch {
        return false;
      }
    };

    if (!isValidURL(link)) {
      newErrors.link = "Invalid URL format";
      hasError = true;
    }

    if (!link) {
      newErrors.link = "Please enter link";
      hasError = true;
    }

    setErrors(newErrors);

    if (hasError) return;

    if (editLinkId) {
      handleUpdateLink(editLinkId);
    } else {
      handleAddLink();
    }
  };

  const handleGetLinks = async (e) => {
    try {
      setLoading(true);
      let response = await fetch(
        `${REACT_APP_API_URL}links?type=${activeTab}&page=${currentPage}&limit=10`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
        }
      );

      response = await response.json();
      console.log(response);

      if (Array.isArray(response.data)) {
        setLinks(response.data);
        setFilteredLinks(response.data);
        // setTotalPages(response.data.totalPages);
      } else {
        setLinks([]);
        setFilteredLinks([]);
      }
    } catch (error) {
      console.error(error);
      showToast("error", "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteLink = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        let response = await fetch(`${REACT_APP_API_URL}delete-link/${id}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
        });

        response = await response.json();

        if (response.success) {
          Swal.fire("Deleted!", "Link has been deleted.", "success");
          setLinks((prev) =>
            prev.filter((link) => String(link.id) !== String(id))
          );
          setFilteredLinks((prev) =>
            prev.filter((link) => String(link.id) !== String(id))
          );
        } else {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateLink = async (id) => {
    try {
      const response = await fetch(`${REACT_APP_API_URL}edit-link/${id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        },
        body: JSON.stringify({
          title,
          url: link,
          type,
        }),
      });

      const data = await response.json();

      if (data.success) {
        showToast("success", "Link updated successfully");
        setIsLinkAdd(true);
      } else {
        showToast("error", "Link not updated");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLink("");
      setTitle("");
    }
  };

  const handleEditClick = (linkData) => {
    setTitle(linkData.title);
    setLink(linkData.url);
    setType(linkData.type);
    setEditLinkId(linkData.id);
  };

  return (
    <Layout>
      <Nav variant="pills">
        <Nav.Item className="mb-3 d-flex justify-content-between w-100">
          <Nav.Link
            className={`w-auto me-2 ${
              activeTab === "accommodation" ? "active" : ""
            }`}
            onClick={() => handleTabClick("accommodation")}
          >
            Accommodation
          </Nav.Link>
          <Nav.Link
            className={`w-auto ${activeTab === "travel" ? "active" : ""}`}
            onClick={() => handleTabClick("travel")}
          >
            Travel
          </Nav.Link>
          <Nav.Link
            className={`w-auto me-2 ${activeTab === "meal" ? "active" : ""}`}
            onClick={() => handleTabClick("meal")}
          >
            Meal
          </Nav.Link>
          <Nav.Link
            className={`w-auto ${activeTab === "golf" ? "active" : ""}`}
            onClick={() => handleTabClick("golf")}
          >
            Golf
          </Nav.Link>
          <Nav.Link
            className={`w-auto ${
              activeTab === "entertainment" ? "active" : ""
            }`}
            onClick={() => handleTabClick("entertainment")}
          >
            Entertainment
          </Nav.Link>
        </Nav.Item>
      </Nav>

      <div className="tab-content p-0">
        <div className="card">
          <div className="card-body">
            {activeTab === "accommodation" && (
              <div>
                <div className="d-flex align-items-center justify-content-end mb-4">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-outline-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#addAccommodation"
                    >
                      Add
                    </button>
                  </div>
                </div>
                <div className="table-responsive text-nowrap">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Title</th>
                        <th>Link</th>
                        <th>Option</th>
                      </tr>
                    </thead>
                    <tbody className="table-border-bottom-0">
                      {loading ? (
                        [...Array(5)].map((_, index) => (
                          <tr key={index}>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "20px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{
                                  width: "65px",
                                  height: "65px",
                                  borderRadius: "50%",
                                }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "120px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "150px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "40px", height: "20px" }}
                              ></div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <div
                                  className="shimmer-loader"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                                <div
                                  className="shimmer-loader"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : filteredLinks.length > 0 ? (
                        filteredLinks.map((link, index) => (
                          <tr key={link.id}>
                            <td>{index + 1}</td>
                            <td>{link.title}</td>
                            <td>
                              <a
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {link.url}
                              </a>
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  className="btn btn-icon badge bg-label-success"
                                  data-bs-toggle="modal"
                                  data-bs-target="#addAccommodation"
                                  onClick={() => handleEditClick(link)}
                                >
                                  <BiSolidPencil className="icon-md bx" />
                                </button>
                                <button
                                  className="btn btn-icon delete-record badge bg-label-danger"
                                  onClick={() => handleDeleteLink(link.id)}
                                >
                                  <BiTrash className="icon-md bx" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            {searchQuery.trim() !== ""
                              ? "No links match your search criteria."
                              : "No links found."}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination - Only show when not searching */}
                {totalPages > 1 && (
                  <div className="d-flex justify-content-center py-3">
                    <nav>
                      <ul className="pagination">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link rounded-2 px-3"
                            onClick={() =>
                              setCurrentPage((prev) => Math.max(1, prev - 1))
                            }
                          >
                            Previous
                          </button>
                        </li>

                        {Array.from(
                          { length: totalPages },
                          (_, i) => i + 1
                        ).map((page) => (
                          <li
                            key={page}
                            className={`page-item ${
                              currentPage === page ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setCurrentPage(page)}
                            >
                              {page}
                            </button>
                          </li>
                        ))}

                        <li
                          className={`page-item ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link rounded-2 px-3"
                            onClick={() =>
                              setCurrentPage((prev) =>
                                Math.min(totalPages, prev + 1)
                              )
                            }
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}

                {/* </tbody>
                  </table>
                </div> */}

                <div
                  className="modal fade"
                  id="addAccommodation"
                  tabIndex="-1"
                  data-bs-backdrop="static"
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Add Accommodation</h5>
                        <button
                          id="addCloseBtn"
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          onClick={handleCloseForm}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="mb-3">
                          <label className="form-label">Title</label>
                          <Inputbox
                            type="text"
                            placeholder="Enter title"
                            className="form-control"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                          />
                          {errors.title && (
                            <small className="text-danger">
                              {errors.title}
                            </small>
                          )}
                        </div>
                        <div>
                          <label className="form-label">Link</label>
                          <Inputbox
                            type="text"
                            placeholder="Enter link"
                            className="form-control"
                            value={link}
                            onChange={(e) => setLink(e.target.value)}
                          />
                          {errors.link && (
                            <small className="text-danger">{errors.link}</small>
                          )}
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-label-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <Button type="button" onClick={handleAddSubmit}>
                          {editLinkId ? "Update" : "Add"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === "travel" && (
              <div>
                <div className="d-flex align-items-center justify-content-end mb-4">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-outline-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#addTravel"
                    >
                      Add
                    </button>
                  </div>
                </div>
                <div className="table-responsive text-nowrap">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Title</th>
                        <th>Link</th>
                        <th>Option</th>
                      </tr>
                    </thead>
                    <tbody className="table-border-bottom-0">
                      {loading ? (
                        [...Array(5)].map((_, index) => (
                          <tr key={index}>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "20px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{
                                  width: "65px",
                                  height: "65px",
                                  borderRadius: "50%",
                                }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "120px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "150px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "40px", height: "20px" }}
                              ></div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <div
                                  className="shimmer-loader"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                                <div
                                  className="shimmer-loader"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : filteredLinks.length > 0 ? (
                        filteredLinks.map((link, index) => (
                          <tr key={link.id}>
                            <td>{index + 1}</td>
                            <td>{link.title}</td>
                            <td>
                              <a
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {link.url}
                              </a>
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  className="btn btn-icon badge bg-label-success"
                                  data-bs-toggle="modal"
                                  data-bs-target="#addTravel"
                                  onClick={() => handleEditClick(link)}
                                >
                                  <BiSolidPencil className="icon-md bx" />
                                </button>
                                <button
                                  className="btn btn-icon delete-record badge bg-label-danger"
                                  onClick={() => handleDeleteLink(link.id)}
                                >
                                  <BiTrash className="icon-md bx" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            {searchQuery.trim() !== ""
                              ? "No links match your search criteria."
                              : "No links found."}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div
                  className="modal fade"
                  id="addTravel"
                  tabIndex="-1"
                  data-bs-backdrop="static"
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Add Travel</h5>
                        <button
                          id="addCloseBtn"
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          onClick={handleCloseForm}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="mb-3">
                          <label className="form-label">Title</label>
                          <Inputbox
                            type="text"
                            placeholder="Enter title"
                            className="form-control"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                          />
                          {errors.title && (
                            <small className="text-danger">
                              {errors.title}
                            </small>
                          )}
                        </div>
                        <div>
                          <label className="form-label">Link</label>
                          <Inputbox
                            type="text"
                            placeholder="Enter link"
                            className="form-control"
                            value={link}
                            onChange={(e) => setLink(e.target.value)}
                          />
                          {errors.link && (
                            <small className="text-danger">{errors.link}</small>
                          )}
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-label-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <Button type="button" onClick={handleAddSubmit}>
                          {editLinkId ? "Update" : "Add"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === "meal" && (
              <div>
                <div className="d-flex align-items-center justify-content-end mb-4">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-outline-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#addMeal"
                    >
                      Add
                    </button>
                  </div>
                </div>
                <div className="table-responsive text-nowrap">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Title</th>
                        <th>Link</th>
                        <th>Option</th>
                      </tr>
                    </thead>
                    <tbody className="table-border-bottom-0">
                      {loading ? (
                        [...Array(5)].map((_, index) => (
                          <tr key={index}>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "20px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{
                                  width: "65px",
                                  height: "65px",
                                  borderRadius: "50%",
                                }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "120px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "150px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "40px", height: "20px" }}
                              ></div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <div
                                  className="shimmer-loader"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                                <div
                                  className="shimmer-loader"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : filteredLinks.length > 0 ? (
                        filteredLinks.map((link, index) => (
                          <tr key={link.id}>
                            <td>{index + 1}</td>
                            <td>{link.title}</td>
                            <td>
                              <a
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {link.url}
                              </a>
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  className="btn btn-icon badge bg-label-success"
                                  data-bs-toggle="modal"
                                  data-bs-target="#addMeal"
                                  onClick={() => handleEditClick(link)}
                                >
                                  <BiSolidPencil className="icon-md bx" />
                                </button>
                                <button
                                  className="btn btn-icon delete-record badge bg-label-danger"
                                  onClick={() => handleDeleteLink(link.id)}
                                >
                                  <BiTrash className="icon-md bx" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            {searchQuery.trim() !== ""
                              ? "No links match your search criteria."
                              : "No links found."}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div
                  className="modal fade"
                  id="addMeal"
                  tabIndex="-1"
                  data-bs-backdrop="static"
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Add Meal</h5>
                        <button
                          id="addCloseBtn"
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          onClick={handleCloseForm}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="mb-3">
                          <label className="form-label">Title</label>
                          <Inputbox
                            type="text"
                            placeholder="Enter title"
                            className="form-control"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                          />
                          {errors.title && (
                            <small className="text-danger">
                              {errors.title}
                            </small>
                          )}
                        </div>
                        <div>
                          <label className="form-label">Link</label>
                          <Inputbox
                            type="text"
                            placeholder="Enter link"
                            className="form-control"
                            value={link}
                            onChange={(e) => setLink(e.target.value)}
                          />
                          {errors.link && (
                            <small className="text-danger">{errors.link}</small>
                          )}
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-label-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <Button type="button" onClick={handleAddSubmit}>
                          {editLinkId ? "Update" : "Add"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === "golf" && (
              <div>
                <div className="d-flex align-items-center justify-content-end mb-4">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-outline-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#addGolf"
                    >
                      Add
                    </button>
                  </div>
                </div>
                <div className="table-responsive text-nowrap">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Title</th>
                        <th>Link</th>
                        <th>Option</th>
                      </tr>
                    </thead>
                    <tbody className="table-border-bottom-0">
                      {loading ? (
                        [...Array(5)].map((_, index) => (
                          <tr key={index}>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "20px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{
                                  width: "65px",
                                  height: "65px",
                                  borderRadius: "50%",
                                }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "120px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "150px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "40px", height: "20px" }}
                              ></div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <div
                                  className="shimmer-loader"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                                <div
                                  className="shimmer-loader"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : filteredLinks.length > 0 ? (
                        filteredLinks.map((link, index) => (
                          <tr key={link.id}>
                            <td>{index + 1}</td>
                            <td>{link.title}</td>
                            <td>
                              <a
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {link.url}
                              </a>
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  className="btn btn-icon badge bg-label-success"
                                  data-bs-toggle="modal"
                                  data-bs-target="#addGolf"
                                  onClick={() => handleEditClick(link)}
                                >
                                  <BiSolidPencil className="icon-md bx" />
                                </button>
                                <button
                                  className="btn btn-icon delete-record badge bg-label-danger"
                                  onClick={() => handleDeleteLink(link.id)}
                                >
                                  <BiTrash className="icon-md bx" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            {searchQuery.trim() !== ""
                              ? "No links match your search criteria."
                              : "No links found."}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div
                  className="modal fade"
                  id="addGolf"
                  tabIndex="-1"
                  data-bs-backdrop="static"
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Add Golf</h5>
                        <button
                          id="addCloseBtn"
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          onClick={handleCloseForm}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="mb-3">
                          <label className="form-label">Title</label>
                          <Inputbox
                            type="text"
                            placeholder="Enter title"
                            className="form-control"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                          />
                          {errors.title && (
                            <small className="text-danger">
                              {errors.title}
                            </small>
                          )}
                        </div>
                        <div>
                          <label className="form-label">Link</label>
                          <Inputbox
                            type="text"
                            placeholder="Enter link"
                            className="form-control"
                            value={link}
                            onChange={(e) => setLink(e.target.value)}
                          />
                          {errors.link && (
                            <small className="text-danger">{errors.link}</small>
                          )}
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-label-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <Button type="button" onClick={handleAddSubmit}>
                          {editLinkId ? "Update" : "Add"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === "entertainment" && (
              <div>
                <div className="d-flex align-items-center justify-content-end mb-4">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-outline-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#addEntertainment"
                    >
                      Add
                    </button>
                  </div>
                </div>
                <div className="table-responsive text-nowrap">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Title</th>
                        <th>Link</th>
                        <th>Option</th>
                      </tr>
                    </thead>
                    <tbody className="table-border-bottom-0">
                      {loading ? (
                        [...Array(5)].map((_, index) => (
                          <tr key={index}>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "20px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{
                                  width: "65px",
                                  height: "65px",
                                  borderRadius: "50%",
                                }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "120px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "150px" }}
                              ></div>
                            </td>
                            <td>
                              <div
                                className="shimmer-loader"
                                style={{ width: "40px", height: "20px" }}
                              ></div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <div
                                  className="shimmer-loader"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                                <div
                                  className="shimmer-loader"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : filteredLinks.length > 0 ? (
                        filteredLinks.map((link, index) => (
                          <tr key={link.id}>
                            <td>{index + 1}</td>
                            <td>{link.title}</td>
                            <td>
                              <a
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {link.url}
                              </a>
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  className="btn btn-icon badge bg-label-success"
                                  data-bs-toggle="modal"
                                  data-bs-target="#addEntertainment"
                                  onClick={() => handleEditClick(link)}
                                >
                                  <BiSolidPencil className="icon-md bx" />
                                </button>
                                <button
                                  className="btn btn-icon delete-record badge bg-label-danger"
                                  onClick={() => handleDeleteLink(link.id)}
                                >
                                  <BiTrash className="icon-md bx" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            {searchQuery.trim() !== ""
                              ? "No links match your search criteria."
                              : "No links found."}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div
                  className="modal fade"
                  id="addEntertainment"
                  tabIndex="-1"
                  data-bs-backdrop="static"
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Add Entertainment</h5>
                        <button
                          id="addCloseBtn"
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          onClick={handleCloseForm}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="mb-3">
                          <label className="form-label">Title</label>
                          <Inputbox
                            type="text"
                            placeholder="Enter title"
                            className="form-control"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                          />
                          {errors.title && (
                            <small className="text-danger">
                              {errors.title}
                            </small>
                          )}
                        </div>
                        <div>
                          <label className="form-label">Link</label>
                          <Inputbox
                            type="text"
                            placeholder="Enter link"
                            className="form-control"
                            value={link}
                            onChange={(e) => setLink(e.target.value)}
                          />
                          {errors.link && (
                            <small className="text-danger">{errors.link}</small>
                          )}
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-label-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <Button type="button" onClick={handleAddSubmit}>
                          {editLinkId ? "Update" : "Add"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Links;
